import { Box } from 'uiKit/atoms/Box/Box';
import cn from 'classnames';
import styles from '../Modal/Modal.module.scss';

type FooterProps = {
  className?: string;
  children: React.ReactNode;
};

export const Footer = ({ className, children }: FooterProps) => {
  return <Box className={cn(styles.modal__footer, className)}>{children}</Box>;
};
